import React from 'react';
import './ShinyText.css';

const ShinyText = ({
  text,
  disabled = false,
  speed = 3,
  className = '',
  shimmerColor = 'rgba(255, 255, 255, 0.8)',
  children
}) => {
  const animationDuration = `${speed}s`;

  return (
    <span
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
      style={{
        animationDuration,
        '--shimmer-color': shimmerColor
      }}
    >
      {text || children}
    </span>
  );
};

export default ShinyText;
